export enum SectionTypes {
  SHAPE = 'Shape',
  SIZE = 'Size',
  STYLE = 'Style',
  COLOR = 'Color',
  MAT = 'Mat',
  ORIENTATION = 'Orientation',
  PRODUCT = 'Product',
  GALLERYSIZE = 'GallerySize',
  FAMILY = 'Family',
  FINISH = 'Finish',
}

export enum PageType {
  LP = 'LP',
  BASE = 'BASE',
  BASEV2 = 'BASEV2',
}
